import { render, staticRenderFns } from "./MessageSet.vue?vue&type=template&id=3d9c06f4&scoped=true"
import script from "./MessageSet.vue?vue&type=script&lang=js"
export * from "./MessageSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9c06f4",
  null
  
)

export default component.exports